import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Cloud, CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const FreePreviewSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const state = searchParams.get('state');
  const zipCode = searchParams.get('zip');

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-6">
            <Cloud className="w-10 h-10 text-blue-600" />
            <span className="text-2xl font-bold text-slate-900">OwnerConnect</span>
          </div>
        </div>

        {/* Success Card */}
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-8 sm:p-12 text-center">
          {/* Success Icon */}
          <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>

          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Your List is Ready!
          </h1>

          {/* Body */}
          <p className="text-lg text-slate-700 mb-6">
            We've sent 100 verified homeowners to <span className="font-semibold text-blue-600">{email}</span>
          </p>

          {/* Checkmarks */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8 text-left inline-block">
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-sm text-slate-800">All homeowners (no renters)</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-sm text-slate-800">All have valid phone numbers</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-sm text-slate-800">All DNC numbers excluded</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-sm text-slate-800">Sorted alphabetically for easy assignment</span>
              </div>
            </div>
          </div>

          {/* What's Next */}
          <div className="border-t border-slate-200 pt-8 mt-8">
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              What's Next?
            </h2>
            <p className="text-slate-600 mb-6">
              Most roofing teams book 1-2 jobs from these first 100 leads. Ready to scale to 10,000 or 30,000?
            </p>
            <Button
              size="lg"
              onClick={() => navigate('/roofers-paid#pricing')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-bold"
            >
              See Full Pricing <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-slate-500 text-sm mt-8">
          Questions? Email us at support@ownerconnect.io
        </p>
      </div>
    </div>
  );
};

export default FreePreviewSuccess;
